import { produce } from 'immer';

export const initialState = {
  isSignedIn: undefined,
  signInError: false,
  signInErrorMsg: undefined,
  lockedOut: false,
  registerError: false,
  passwordResetEmail: {
    success: false,
    error: false,
  },
  changePasswordResult: {
    success: false,
    errorMessage: undefined,
  },
  resetPasswordWithTokenResult: {
    success: false,
    errorMessage: undefined,
    errorCode: undefined,
  },
};

const SET_SIGNED_IN = 'SET_SIGNED_IN';
export const setSignedIn = {
  type: SET_SIGNED_IN,
};

const SET_SIGNED_OUT = 'SET_SIGNED_OUT';
export const setSignedOut = {
  type: SET_SIGNED_OUT,
};

const SET_SIGN_IN_ERROR = 'SET_SIGN_IN_ERROR';
export const setSignInError = (error) => ({
  type: SET_SIGN_IN_ERROR,
  payload: error,
});

const SET_REGISTERED = 'SET_REGISTERED';
export const setRegistered = {
  type: SET_REGISTERED,
};

const SET_REGISTER_ERROR = 'SET_REGISTER_ERROR';
export const setRegisterError = (error) => ({
  type: SET_REGISTER_ERROR,
  payload: { error },
});

const CLEAR_PASSWORD_RESET_EMAIL_STATUS = 'CLEAR_PASSWORD_RESET_EMAIL_STATUS';
export const clearPasswordResetEmailStatus = () => ({
  type: CLEAR_PASSWORD_RESET_EMAIL_STATUS,
});

const SET_PASSWORD_RESET_EMAIL_ERROR = 'SET_PASSWORD_RESET_EMAIL_ERROR';
export const setPasswordResetEmailError = (passwordResetEmailError) => ({
  type: SET_PASSWORD_RESET_EMAIL_ERROR,
  payload: { passwordResetEmailError },
});

export const SET_CHANGE_PASSWORD_RESULT = 'SET_CHANGE_PASSWORD_RESULT';
export const setChangePasswordResult = (
  isChangePasswordSuccessful,
  changePasswordErrorMessage,
) => ({
  type: SET_CHANGE_PASSWORD_RESULT,
  payload: {
    isChangePasswordSuccessful: isChangePasswordSuccessful,
    changePasswordErrorMessage: changePasswordErrorMessage,
  },
});

export const SET_RESET_PASSWORD_WITH_TOKEN_RESULT = 'SET_RESET_PASSWORD_WITH_TOKEN_RESULT';
export const setResetPasswordWithTokenResult = (
  isResetPasswordWithTokenSuccessful,
  resetPasswordWithTokenErrorMessage,
  errorCode,
) => ({
  type: SET_RESET_PASSWORD_WITH_TOKEN_RESULT,
  payload: {
    isResetPasswordWithTokenSuccessful: isResetPasswordWithTokenSuccessful,
    resetPasswordWithTokenErrorMessage: resetPasswordWithTokenErrorMessage,
    errorCode: errorCode,
  },
});

export const CLEAR_PASSWORD_CHANGE_STATUS = 'CLEAR_PASSWORD_CHANGE_STATUS';
export const clearPasswordChangeStatus = () => ({
  type: CLEAR_PASSWORD_CHANGE_STATUS,
});

export const CLEAR_PASSWORD_RESET_WITH_TOKEN_STATUS = 'CLEAR_PASSWORD_RESET_WITH_TOKEN_STATUS';
export const clearResetPasswordWithTokenStatus = () => ({
  type: CLEAR_PASSWORD_RESET_WITH_TOKEN_STATUS,
});

const authorization = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, payload } = action;
    switch (type) {
      case SET_SIGNED_IN:
        draft.isSignedIn = true;
        draft.signInError = false;
        draft.signInErrorMsg = undefined;
        break;
      case SET_SIGNED_OUT:
        draft.isSignedIn = false;
        break;
      case CLEAR_PASSWORD_RESET_EMAIL_STATUS:
        draft.passwordResetEmail.success = false;
        draft.passwordResetEmail.error = false;
        break;
      case SET_SIGN_IN_ERROR:
        if (payload?.lockedUntil) {
          draft.lockedOut = !!payload.lockedUntil;
          draft.signInError = false;
        } else {
          draft.lockedOut = false;
          draft.signInError = true;
          draft.signInErrorMsg = payload.errors;
        }
        draft.isSignedIn = false;
        break;
      case SET_REGISTERED:
        draft.isSignedIn = true;
        draft.registerError = false;
        break;
      case SET_REGISTER_ERROR:
        draft.registerError = true;
        draft.isSignedIn = false;
        break;
      case SET_PASSWORD_RESET_EMAIL_ERROR:
        draft.passwordResetEmail.success = !payload.passwordResetEmailError;
        draft.passwordResetEmail.error = payload.passwordResetEmailError;
        break;
      case SET_CHANGE_PASSWORD_RESULT:
        draft.changePasswordResult.success = payload.isChangePasswordSuccessful;
        draft.changePasswordResult.errorMessage = payload.changePasswordErrorMessage;
        break;
      case CLEAR_PASSWORD_CHANGE_STATUS:
        draft.changePasswordResult.success = false;
        draft.changePasswordResult.errorMessage = undefined;
        break;
      case SET_RESET_PASSWORD_WITH_TOKEN_RESULT:
        draft.resetPasswordWithTokenResult.success = payload.isResetPasswordWithTokenSuccessful;
        draft.resetPasswordWithTokenResult.errorMessage =
          payload.resetPasswordWithTokenErrorMessage;
        draft.resetPasswordWithTokenResult.errorCode = payload.errorCode;
        break;
      case CLEAR_PASSWORD_RESET_WITH_TOKEN_STATUS:
        draft.resetPasswordWithTokenResult.success = false;
        draft.resetPasswordWithTokenResult.errorMessage = undefined;
        draft.resetPasswordWithTokenResult.errorCode = undefined;
        break;
      default:
        break;
    }
  });

export default authorization;
